import React, { useEffect, useState, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { Apiurl } from "../../shared/services/apirest";
import "bootstrap/dist/css/bootstrap.min.css";
import bootstrap from "bootstrap/dist/js/bootstrap.bundle";
import "bootstrap-icons/font/bootstrap-icons.css";
import AdminLayout from "../../modules/dashboard/AdminLayout";
import "../../assets/css/NewUser.css";
import LocationService from "../../shared/services/LocationService";

function Edit() {
  const { id } = useParams();
  const navigate = useNavigate();
  const toastRef = useRef(null);

  const [usuario, setUsuario] = useState({
    email: "",
    role: "laboratorio",
    municipio: "",
    departamento: "",
    nombre_laboratorio: "",
    telefonos: "",
    direccion: "",
    horario: "",
    latitud: "",
    longitud: ""
  });

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [showPasswordSection, setShowPasswordSection] = useState(false);
  const [locationsHierarchy, setLocationsHierarchy] = useState({});
  const [municipiosList, setMunicipiosList] = useState([]);

  useEffect(() => {
    // Fetch Locations from API
    const fetchLocations = async () => {
      try {
        const hierarchy = await LocationService.getHierarchy();
        setLocationsHierarchy(hierarchy);
        setMunicipiosList(Object.keys(hierarchy).sort());
      } catch (error) {
        console.error("Error loading locations", error);
      }
    };
    fetchLocations();
  }, []);

  const handleMunicipioChange = (e) => {
    const municipioName = e.target.value;

    // Find coords in the hierarchy
    let lat = "";
    let lng = "";

    if (locationsHierarchy[municipioName]) {
      // Try Urbana -> Centro
      const urb = locationsHierarchy[municipioName]["Urbana"];
      if (urb && urb["Centro"]) {
        lat = urb["Centro"].lat;
        lng = urb["Centro"].lng;
      } else if (urb) {
        const first = Object.values(urb)[0];
        if (first) { lat = first.lat; lng = first.lng; }
      } else {
        // Try Rural
        const rur = locationsHierarchy[municipioName]["Rural"];
        if (rur) {
          const first = Object.values(rur)[0];
          if (first) { lat = first.lat; lng = first.lng; }
        }
      }
    }

    setUsuario({
      ...usuario,
      municipio: municipioName,
      latitud: lat,
      longitud: lng,
    });
  };

  const showToast = (message, type = "success") => {
    const toastEl = toastRef.current;
    if (toastEl) {
      const bsToast = new bootstrap.Toast(toastEl);
      const toastBody = toastEl.querySelector(".toast-body");
      toastBody.textContent = message;
      toastEl.className = `toast align-items-center border-0 text-bg-${type} shadow-lg`;
      bsToast.show();
    }
  };

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      navigate("/Login");
      return;
    }

    const url = `${Apiurl}users/Update_User/${id}/`;
    const config = { headers: { Authorization: `Bearer ${token}` } };

    axios
      .get(url, config)
      .then((response) => {
        setUsuario(prev => ({ ...prev, ...response.data }));
      })
      .catch((err) => {
        console.error("Error al cargar el usuario:", err);
        setError("Error al cargar la información del usuario.");
      })
      .finally(() => setLoading(false));
  }, [id, navigate]);

  const handleChange = (e) => {
    setUsuario({ ...usuario, [e.target.name]: e.target.value });
  };

  const handleRoleChange = (role) => {
    setUsuario({ ...usuario, role });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const token = localStorage.getItem("token");
    const url = `${Apiurl}users/Update_User/${id}/`;
    const config = { headers: { Authorization: `Bearer ${token}` } };

    // Sanitizar datos: Convertir strings vacíos de lat/long a null
    const payload = { ...usuario };
    if (payload.latitud === "" || payload.latitud === undefined) payload.latitud = null;
    if (payload.longitud === "" || payload.longitud === undefined) payload.longitud = null;

    // Para roles que no son laboratorio, limpiar campos específicos que no aplican
    if (payload.role !== "laboratorio") {
      delete payload.cod_laboratorio;
    }

    axios
      .put(url, payload, config)
      .then((res) => {
        const msg = res.data?.detail || "✅ Usuario actualizado correctamente.";
        setSuccess(msg);
        showToast(msg, "success");
        setTimeout(() => navigate("/DashboardAdmin"), 1600);
      })
      .catch((err) => {
        const msg = err.response?.data?.detail || "❌ Error al actualizar los datos.";
        setError(msg);
        showToast(msg, "danger");
      });
  };

  const handlePasswordChange = () => {
    if (!newPassword || newPassword.length < 8) {
      showToast("La contraseña debe tener al menos 8 caracteres.", "warning");
      return;
    }

    const token = localStorage.getItem("token");
    const url = `${Apiurl}users/change_password/`;
    const config = { headers: { Authorization: `Bearer ${token}` } };
    const payload = {
      user_id: id,
      new_password: newPassword
    };

    axios
      .post(url, payload, config)
      .then((res) => {
        const msg = res.data?.detail || "✅ Contraseña actualizada correctamente.";
        showToast(msg, "success");
        setNewPassword("");
        setShowPasswordSection(false);
      })
      .catch((err) => {
        console.error("Error al cambiar contraseña:", err.response?.data);
        let msg = "❌ Error al cambiar la contraseña.";

        // Show detailed error if available
        if (err.response?.data?.detail) {
          msg = err.response.data.detail;
        } else if (err.response?.data?.new_password) {
          // Password validation errors
          const errors = err.response.data.new_password;
          msg = Array.isArray(errors) ? errors.join("\n") : errors;
        } else if (err.response?.data) {
          // Other validation errors
          const errors = Object.values(err.response.data).flat();
          msg = errors.join("\n");
        }

        showToast(msg, "danger");
      });
  };

  const renderLabFields = () => (
    <div className="animate__animated animate__fadeIn">
      <div className="section-header mt-4">
        <i className="bi bi-building"></i>
        <h5>Detalles del Laboratorio / Entidad</h5>
      </div>

      <div className="row">
        <div className="col-md-7 custom-input-group">
          <label>Nombre de la Entidad</label>
          <div className="input-with-icon">
            <i className="bi bi-hospital"></i>
            <input type="text" name="nombre_laboratorio" value={usuario.nombre_laboratorio} onChange={handleChange} className="form-control input-professional" required placeholder="Nombre oficial" />
          </div>
        </div>
        <div className="col-md-5 custom-input-group">
          <label>Cód. Habilitación</label>
          <div className="input-with-icon">
            <i className="bi bi-hash"></i>
            <input type="text" name="cod_laboratorio" value={usuario.cod_laboratorio} onChange={handleChange} className="form-control input-professional" placeholder="Ej: 23001000" disabled />
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-md-6 custom-input-group">
          <label>Dirección Física</label>
          <div className="input-with-icon">
            <i className="bi bi-geo-alt"></i>
            <input type="text" name="direccion" value={usuario.direccion} onChange={handleChange} className="form-control input-professional" required placeholder="Calle, Carrera, No." />
          </div>
        </div>
        <div className="col-md-6 custom-input-group">
          <label>Teléfonos de Contacto</label>
          <div className="input-with-icon">
            <i className="bi bi-telephone"></i>
            <input type="text" name="telefonos" value={usuario.telefonos} onChange={handleChange} className="form-control input-professional" required placeholder="Fijos o celulares" />
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-md-4 custom-input-group">
          <label>Departamento</label>
          <input type="text" name="departamento" value={usuario.departamento} onChange={handleChange} className="form-control input-professional" />
        </div>
        <div className="col-md-4 custom-input-group">
          <label>Municipio</label>
          <select
            name="municipio"
            value={usuario.municipio}
            onChange={handleMunicipioChange}
            className="form-select input-professional"
          >
            <option value="">Seleccione un municipio</option>
            {municipiosList.map(m => (
              <option key={m} value={m}>{m}</option>
            ))}
          </select>
        </div>
        <div className="col-md-4 custom-input-group">
          <label>Horario de Atención</label>
          <div className="input-with-icon">
            <i className="bi bi-clock"></i>
            <input type="text" name="horario" value={usuario.horario} onChange={handleChange} className="form-control input-professional" placeholder="Ej: 7am - 5pm" />
          </div>
        </div>
      </div>

      <div className="section-header mt-3">
        <i className="bi bi-map"></i>
        <h5>Coordenadas Geográficas (Opcional)</h5>
      </div>
      <div className="row">
        <div className="col-md-6 custom-input-group">
          <label>Latitud</label>
          <input type="number" step="any" name="latitud" value={usuario.latitud || ''} onChange={handleChange} className="form-control input-professional" placeholder="Ej: 8.7512" />
        </div>
        <div className="col-md-6 custom-input-group">
          <label>Longitud</label>
          <input type="number" step="any" name="longitud" value={usuario.longitud || ''} onChange={handleChange} className="form-control input-professional" placeholder="Ej: -75.8821" />
        </div>
      </div>
    </div>
  );

  const renderAdminFields = () => (
    <div className="animate__animated animate__fadeIn">
      <div className="section-header mt-4">
        <i className="bi bi-person-badge"></i>
        <h5>Información Personal</h5>
      </div>
      <div className="custom-input-group">
        <label>Nombre Completo</label>
        <div className="input-with-icon">
          <i className="bi bi-person"></i>
          <input type="text" name="nombre_laboratorio" value={usuario.nombre_laboratorio} onChange={handleChange} className="form-control input-professional" required placeholder="Nombre y apellidos" />
        </div>
      </div>
      <div className="info-alert">
        <i className="bi bi-info-circle-fill"></i>
        <div>
          Los roles administrativos e investigadores no requieren geolocalización o códigos de habilitación de laboratorio.
        </div>
      </div>
    </div>
  );

  return (
    <AdminLayout
      breadcrumb={`Panel de Administración / Usuarios / Editar Perfil / ${id}`}
      title="Editar Usuario"
    >
      <div className="toast-container position-fixed top-0 end-0 p-3" style={{ zIndex: 1055 }}>
        <div ref={toastRef} className="toast" role="alert" aria-live="assertive" aria-atomic="true">
          <div className="d-flex">
            <div className="toast-body fw-semibold"></div>
            <button type="button" className="btn-close me-2 m-auto" data-bs-dismiss="toast" aria-label="Cerrar"></button>
          </div>
        </div>
      </div>

      <div className="new-user-container">
        {loading ? (
          <div className="text-center py-5">
            <div className="spinner-border text-primary" role="status"></div>
            <p className="mt-2 text-muted">Cargando datos del usuario...</p>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            {error && <div className="alert alert-danger rounded-3" role="alert">{error}</div>}
            {success && <div className="alert alert-success rounded-3" role="alert">{success}</div>}

            <div className="form-section">
              <div className="section-header">
                <i className="bi bi-key"></i>
                <h5>Configuración de Cuenta</h5>
              </div>

              <div className="row">
                <div className="col-md-6 custom-input-group">
                  <label>Correo Electrónico</label>
                  <div className="input-with-icon">
                    <i className="bi bi-envelope"></i>
                    <input type="email" name="email" value={usuario.email} onChange={handleChange} required className="form-control input-professional" placeholder="usuario@geohcx.com" />
                  </div>
                </div>
                <div className="col-md-6 custom-input-group">
                  <label>Rol del Usuario</label>
                  <div className="role-badge-selector">
                    {['laboratorio', 'investigador', 'visualizador', 'admin'].map(role => (
                      <div
                        key={role}
                        className={`role-option ${usuario.role === role ? 'active' : ''}`}
                        onClick={() => handleRoleChange(role)}
                      >
                        {role.charAt(0).toUpperCase() + role.slice(1)}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>

            <div className="form-section">
              <div className="section-header">
                <i className="bi bi-shield-lock"></i>
                <h5>Cambiar Contraseña</h5>
              </div>

              {!showPasswordSection ? (
                <button
                  type="button"
                  className="btn btn-outline-primary"
                  onClick={() => setShowPasswordSection(true)}
                >
                  <i className="bi bi-key me-2"></i>
                  Cambiar Contraseña del Usuario
                </button>
              ) : (
                <div className="animate__animated animate__fadeIn">
                  <div className="row">
                    <div className="col-md-8 custom-input-group">
                      <label>Nueva Contraseña</label>
                      <div className="input-with-icon">
                        <i className="bi bi-lock"></i>
                        <input
                          type="password"
                          value={newPassword}
                          onChange={(e) => setNewPassword(e.target.value)}
                          className="form-control input-professional"
                          placeholder="Mínimo 8 caracteres (no usar contraseñas comunes)"
                          minLength="8"
                        />
                      </div>
                    </div>
                    <div className="col-md-4 d-flex align-items-end gap-2">
                      <button
                        type="button"
                        className="btn btn-success"
                        onClick={handlePasswordChange}
                      >
                        <i className="bi bi-check-circle me-1"></i>
                        Actualizar
                      </button>
                      <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={() => {
                          setShowPasswordSection(false);
                          setNewPassword("");
                        }}
                      >
                        Cancelar
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>

            <div className="form-section">
              {usuario.role === 'laboratorio' ? renderLabFields() : renderAdminFields()}
            </div>

            <div className="form-footer-actions">
              <button type="button" className="btn btn-light btn-professional" onClick={() => navigate("/DashboardAdmin")}>
                Descartar Cambios
              </button>
              <button type="submit" className="btn btn-professional btn-submit-user">
                <i className="bi bi-check2-circle me-2"></i> Guardar Cambios
              </button>
            </div>
          </form>
        )}
      </div>
    </AdminLayout>
  );
}

export default Edit;
